module.exports = {"131124100":"饶阳镇","131124101":"大尹村镇","131124102":"五公镇","131124103":"大官亭镇","131124104":"王同岳镇","131124105":"东里满镇","131124106":"留楚镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131124.json
// module id = 335
// module chunks = 0